module.exports = __webpack_public_path__ + "images/164ca977f5ff8410796469857594321b.png";


//////////////////
// WEBPACK FOOTER
// ../public/images/gift-bottle-bag.png
// module id = 1091
// module chunks = 0